<template>
  <div class="bind-page-layout">
    <div class="main-content">
      <div class="top-fixed-area">
        <div class="search-bar" style="position: relative; width: 600px">
          <el-input
            placeholder="搜索"
            style="width: 600px"
            v-model="searchKeyword"
          ></el-input>
          <img
            @click="handleSearchClick"
            style="
              width: 25px;
              height: 29px;
              position: absolute;
              right: 0;
              bottom: 1px;
              cursor: pointer;
            "
            :src="imgurl"
            alt=""
          />
        </div>
        <div class="top-nav">
          <el-menu
            mode="horizontal"
            text-color="#333"
            active-text-color="#C1272D"
            :default-active="activeCategoryId"
            @select="handleCategoryChange"
          >
            <el-menu-item key="" index=""> 推荐 </el-menu-item>
            <el-menu-item
              v-for="category in fllist"
              :key="category.id"
              :index="category.id.toString()"
            >
              {{ category.name }}
            </el-menu-item>
          </el-menu>
        </div>
      </div>
      <!-- 主体 -->
      <div class="page-scroll-wrap">
        <div class="two-col-container">
          <!-- 左侧：星球样衣 未绑定 -->
          <div class="col-left">
            <h2 class="page-title">星球样衣</h2>
            <div class="card-scroll-box">
              <div class="goods-grid left-grid">
                <div class="goods-item" v-for="item in wbdlist" :key="item.id">
                  <div class="item-row">
                    <div class="goods-img-wrap">
                      <el-image
                        :src="getFullImgUrl(item.coverUrl)"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="tag-group">
                      <span
                        class="supply-tag"
                        @click="openSupplyDialog(item, 'ml')"
                        >面料供应</span
                      >
                      <span
                        class="supply-tag"
                        @click="openSupplyDialog(item, 'fu')"
                        >辅料供应</span
                      >
                    </div>
                  </div>
                  <div class="goods-no-text">样衣编号:{{ item.outerKey }}</div>
                </div>
                <div v-if="wbdlist.length === 0" class="empty-tip">
                  暂无未绑定样衣
                </div>
              </div>
            </div>
          </div>
          <!-- 中间箭头 -->
          <div class="center-arrow">
            <span>⟫</span>
          </div>
          <!-- 右侧：已绑定 -->
          <div class="col-right">
            <h2 class="page-title">已绑定：{{ ybdlist.length }}个</h2>
            <div class="card-scroll-box">
              <div class="goods-grid right-grid">
                <div class="goods-item" v-for="item in ybdlist" :key="item.id">
                  <div class="item-row">
                    <div class="goods-img-wrap">
                      <el-image
                        :src="getFullImgUrl(item.coverUrl)"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="bind-info-group">
                      <div class="code-text">
                        <div>本店面料编号:</div>
                        <div>{{ item.fabricStr || "" }}</div>
                      </div>
                      <div class="icon-row">
                        <i
                          class="update-icon el-icon-edit"
                          style="color: #f0ad4e; font-size: 22px"
                          title="修改"
                          @click="openEditDialog(item)"
                        ></i>
                        <i
                          class="del-icon el-icon-close"
                          style="font-size: 22px"
                          title="删除"
                          @click="del"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div class="goods-no-text">样衣编号:{{ item.outerKey }}</div>
                </div>
                <div v-if="ybdlist.length === 0" class="empty-tip">
                  暂无已绑定样衣
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 弹窗区分普通供应 / 修改编辑-->
      <el-dialog
        :title="dialogTitle"
        v-model="dialogVisible"
        :width="dialogMode === 'normal' ? '450px' : '900px'"
        center
        @close="handleDialogClose"
      >
        <!-- 普通模式 -->
        <template v-if="dialogMode === 'normal'">
          <div class="dialog-header-row" style="width: 280px !important">
            <el-input
              v-model="dialogSearchVal"
              placeholder="搜索"
              clearable
              class="search-input"
              prefix-icon="el-icon-search"
            ></el-input>
            <el-button
              style="border: 1px solid #f0ad4e !important"
              @click="handleSaveSupply"
              >保存</el-button
            >
          </div>
          <div class="checkbox-wrap">
            <el-checkbox-group v-model="selectedIds">
              <div class="two-col-checkbox">
                <el-checkbox
                  v-for="opt in filteredDialogList"
                  :key="opt.baseProductId"
                  :label="opt.baseProductId"
                >
                  {{ opt.baseProductName || opt.baseProductId }}
                </el-checkbox>
              </div>
            </el-checkbox-group>
            <div v-if="filteredDialogList.length === 0" class="dialog-empty">
              暂无数据
            </div>
          </div>
        </template>
        <!-- 修改模式-->
        <template v-if="dialogMode === 'edit'">
          <div class="edit-two-col">
            <!-- 左侧面料 -->
            <div class="edit-col">
              <div class="edit-col-header-row">
                <h4 class="edit-col-title">面料修改</h4>
              </div>
              <!-- 搜索+保存按钮同一行 -->
              <div class="edit-search-row">
                <el-input
                  v-model="editMlSearch"
                  placeholder="搜索面料"
                  clearable
                  prefix-icon="el-icon-search"
                  class="edit-search"
                ></el-input>
                <el-button
                  size="small"
                  style="border: 1px solid #f0ad4e !important; font-size: 16px"
                  @click="handleEditSaveMl"
                  >保存面料</el-button
                >
              </div>
              <div class="checkbox-wrap edit-scroll">
                <el-checkbox-group v-model="editMlSelected">
                  <div class="two-col-checkbox">
                    <el-checkbox
                      v-for="opt in filteredMlList"
                      :key="opt.baseProductId"
                      :label="opt.baseProductId"
                    >
                      {{ opt.baseProductName || opt.baseProductId }}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
                <div v-if="filteredMlList.length === 0" class="dialog-empty">
                  暂无面料数据
                </div>
              </div>
            </div>
            <!-- 右侧辅料 -->
            <div class="edit-col">
              <div class="edit-col-header-row">
                <h4 class="edit-col-title">辅料修改</h4>
              </div>
              <!-- 搜索+保存按钮同一行 -->
              <div class="edit-search-row">
                <el-input
                  v-model="editFuSearch"
                  placeholder="搜索辅料"
                  clearable
                  prefix-icon="el-icon-search"
                  class="edit-search"
                ></el-input>
                <el-button
                  size="small"
                  style="
                    border: 1px solid #f0ad4e !important;
                    font-size: 16px !important;
                  "
                  @click="handleEditSaveFu"
                  >保存辅料</el-button
                >
              </div>
              <div class="checkbox-wrap edit-scroll">
                <el-checkbox-group v-model="editFuSelected">
                  <div class="two-col-checkbox">
                    <el-checkbox
                      v-for="opt in filteredFuList"
                      :key="opt.baseProductId"
                      :label="opt.baseProductId"
                    >
                      {{ opt.baseProductName || opt.baseProductId }}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
                <div v-if="filteredFuList.length === 0" class="dialog-empty">
                  暂无辅料数据
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import srcs from "../lalian.png";
const { proxy } = getCurrentInstance();

const imgurl = srcs;
const activeCategoryId = ref("");
const searchKeyword = ref("");
const fllist = ref([]);
const wbdlist = ref([]);
const ybdlist = ref([]);
const mllist = ref([]);
const fulist = ref([]);

//弹窗
const dialogVisible = ref(false);
const dialogTitle = ref("");
const dialogType = ref("");
const dialogMode = ref("normal");
const currentItem = ref(null);
const dialogSearchVal = ref("");
const dialogList = ref([]);
const selectedIds = ref([]);

//编辑模式专用
const editMlSearch = ref("");
const editFuSearch = ref("");
const editMlSelected = ref([]);
const editFuSelected = ref([]);

const filteredDialogList = computed(() => {
  if (!dialogSearchVal.value?.trim()) return dialogList.value;
  const kw = dialogSearchVal.value.trim().toLowerCase();
  return dialogList.value.filter((item) => {
    const name = item.baseProductName || item.name || "";
    return (
      name.toLowerCase().includes(kw) ||
      String(item.baseProductId).toLowerCase().includes(kw)
    );
  });
});

const filteredMlList = computed(() => {
  if (!editMlSearch.value?.trim()) return mllist.value;
  const kw = editMlSearch.value.trim().toLowerCase();
  return mllist.value.filter((item) => {
    const name = item.baseProductName || item.name || "";
    return (
      name.toLowerCase().includes(kw) ||
      String(item.baseProductId).toLowerCase().includes(kw)
    );
  });
});

const filteredFuList = computed(() => {
  if (!editFuSearch.value?.trim()) return fulist.value;
  const kw = editFuSearch.value.trim().toLowerCase();
  return fulist.value.filter((item) => {
    const name = item.baseProductName || item.name || "";
    return (
      name.toLowerCase().includes(kw) ||
      String(item.baseProductId).toLowerCase().includes(kw)
    );
  });
});

//删除功能待完善
const del = () => {
  proxy.$message.error("删除功能待完善");
};

//打开供应弹窗
const openSupplyDialog = async (item, type) => {
  dialogMode.value = "normal";
  currentItem.value = item;
  dialogType.value = type;
  dialogVisible.value = true;
  selectedIds.value = [];
  dialogSearchVal.value = "";
  if (type === "ml") {
    dialogTitle.value = "面料供应";
    await getml(item.id);
    dialogList.value = [...mllist.value].filter((opt) => opt.bindFlag === 0);
  } else {
    dialogTitle.value = "辅料供应";
    await getfl(item.id);
    dialogList.value = [...fulist.value].filter((opt) => opt.bindFlag === 0);
  }
};

//打开修改弹窗
const openEditDialog = async (item) => {
  dialogMode.value = "edit";
  dialogTitle.value = "修改";
  currentItem.value = item;
  dialogVisible.value = true;
  editMlSearch.value = "";
  editFuSearch.value = "";
  editMlSelected.value = [];
  editFuSelected.value = [];
  //同时获取面料、辅料全部数据，不过滤bindFlag
  await Promise.all([getml(item.id), getfl(item.id)]);
  // bindFlag ===1 自动勾选
  editMlSelected.value = mllist.value
    .filter((i) => i.bindFlag === 1)
    .map((i) => i.baseProductId);
  editFuSelected.value = fulist.value
    .filter((i) => i.bindFlag === 1)
    .map((i) => i.baseProductId);
};

//获取面料供应
const getml = async (id) => {
  const sendata = {
    currentPage: 1,
    pageSize: 20,
    productId: id,
    baseProductName: "",
  };
  try {
    const res = await proxy.$api.Promotion.mlget(sendata);
    if (res.data.code == "200") {
      mllist.value = res.data.data.list;
    }
  } catch (error) {
    console.error("获取面料列表请求异常：", error);
  }
};

//获取辅料供应
const getfl = async (id) => {
  const sendata = {
    currentPage: 1,
    pageSize: 20,
    productId: id,
    baseProductName: "",
  };
  try {
    const res = await proxy.$api.Promotion.flget(sendata);
    if (res.data.code == "200") {
      fulist.value = res.data.data.list;
    }
  } catch (error) {
    console.error("获取辅料列表请求异常：", error);
  }
};

//弹窗关闭
const handleDialogClose = () => {
  selectedIds.value = [];
  dialogSearchVal.value = "";
  dialogList.value = [];
  currentItem.value = null;
  dialogType.value = "";
  dialogMode.value = "normal";
  editMlSearch.value = "";
  editFuSearch.value = "";
  editMlSelected.value = [];
  editFuSelected.value = [];
};

//普通模式保存
const handleSaveSupply = async () => {
  const bindList = selectedIds.value.map((baseProductId) => {
    return {
      baseProductId: baseProductId,
      bindFlag: 1,
    };
  });
  const sendata = {
    productId: currentItem.value.id,
    bindList: bindList,
  };
  try {
    let res;
    if (dialogType.value === "ml") {
      res = await proxy.$api.Promotion.mlbd(sendata);
    } else {
      res = await proxy.$api.Promotion.flbd(sendata);
    }
    if (res.data.code === "200") {
      proxy.$message.success(res.data.msg || "保存成功");
      dialogVisible.value = false;
      get();
      gets();
    } else {
      proxy.$message.error(res.data.msg || "保存失败");
    }
  } catch (error) {
    console.error("保存绑定异常：", error);
    proxy.$message.error("请求异常，请重试");
  }
};

const handleEditSaveMl = async () => {
  const bindList = mllist.value.map((item) => {
    return {
      baseProductId: item.baseProductId,
      bindFlag: editMlSelected.value.includes(item.baseProductId) ? 1 : 0,
    };
  });
  const sendata = {
    productId: currentItem.value.id,
    bindList: bindList,
  };
  try {
    const res = await proxy.$api.Promotion.mlbd(sendata);
    if (res.data.code === "200") {
      proxy.$message.success("面料保存成功");
      dialogVisible.value = false;
      get();
      gets();
    } else {
      proxy.$message.error(res.data.msg || "面料保存失败");
    }
  } catch (err) {
    console.error("面料保存异常", err);
    proxy.$message.error("请求异常，请重试");
  }
};

/**
 * 编辑-保存辅料
 * 遍历：选中bindFlag=1；未选中bindFlag=0
 */
const handleEditSaveFu = async () => {
  const bindList = fulist.value.map((item) => {
    return {
      baseProductId: item.baseProductId,
      bindFlag: editFuSelected.value.includes(item.baseProductId) ? 1 : 0,
    };
  });
  const sendata = {
    productId: currentItem.value.id,
    bindList: bindList,
  };
  try {
    const res = await proxy.$api.Promotion.flbd(sendata);
    if (res.data.code === "200") {
      proxy.$message.success("辅料保存成功");
      dialogVisible.value = false;
      get();
      gets();
    } else {
      proxy.$message.error(res.data.msg || "辅料保存失败");
    }
  } catch (err) {
    console.error("辅料保存异常", err);
    proxy.$message.error("请求异常，请重试");
  }
};

const getFullImgUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//.test(url)) {
    return url;
  }
  return `https://${url}`;
};

const getCategoryList = async () => {
  try {
    const res = await proxy.$api.shouye.getfl();
    if (res.data?.code === "200") {
      fllist.value = res.data.data.list;
    }
  } catch (error) {
    console.error("获取分类列表请求异常：", error);
  }
};

const get = async () => {
  const sendata = {
    currentPage: 1,
    pageSize: 20,
    complexSearch: searchKeyword.value.trim(),
    categoryId: activeCategoryId.value,
  };
  try {
    const res = await proxy.$api.Promotion.wbdget(sendata);
    if (res.data.code == "200") {
      wbdlist.value = res.data.data.list;
    }
  } catch (error) {
    console.error("获取未绑定产品请求异常：", error);
  }
};

const gets = async () => {
  const sendata = {
    currentPage: 1,
    pageSize: 20,
    complexSearch: searchKeyword.value.trim(),
    categoryId: activeCategoryId.value,
  };
  try {
    const res = await proxy.$api.Promotion.ybdget(sendata);
    if (res.data.code == "200") {
      ybdlist.value = res.data.data.list;
    }
  } catch (error) {
    console.error("获取绑定产品请求异常：", error);
  }
};

const handleCategoryChange = (categoryId) => {
  activeCategoryId.value = categoryId;
  get();
  gets();
};

const handleSearchClick = () => {
  get();
  gets();
};

onMounted(() => {
  getCategoryList();
  get();
  gets();
});
</script>

<style scoped lang="less">
.bind-page-layout {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
  .main-content {
    width: 100%;
    max-width: 1791px;
    margin: 0 auto;
    padding: 0 20px;
    height: 100vh;
    box-sizing: border-box;
    .top-fixed-area {
      position: absolute;
      top: 0;
      left: 0;
      right: 20px;
      z-index: 10;
      padding: 20px 0;
      background-color: #fff;
      .search-bar {
        margin-bottom: 20px;
      }
      .top-nav {
        .el-menu {
          border-bottom: none;
        }
      }
    }
    .page-scroll-wrap {
      position: absolute;
      top: 163px;
      left: 0;
      right: 20px;
      bottom: 0;
      overflow: hidden;
    }
    .two-col-container {
      display: flex;
      align-items: flex-start;
      gap: 24px;
      padding: 10px 0;
      height: 100%;
      box-sizing: border-box;
    }
    .col-left {
      width: 65%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .col-right {
      width: 35%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .page-title {
      font-size: 26px;
      font-weight: bold;
      margin: 0 0 16px 0;
      flex-shrink: 0;
    }
    .card-scroll-box {
      border: 1px solid #333;
      padding: 20px;
      height: 70vh;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      flex: 0 0 auto;
    }
    .left-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
      gap: 24px;
    }
    .right-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
      gap: 24px;
    }
    .goods-item {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .item-row {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      width: 100%;
    }
    .goods-img-wrap {
      width: 180px;
      flex: 0 0 180px;
      height: 220px;
      background: #f5f5f5;
      overflow: hidden;
      :deep(.el-image) {
        width: 100%;
        height: 100%;
      }
    }
    .tag-group {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 139px;
      .supply-tag {
        border: 1px solid #f0ad4e;
        color: #666;
        border-radius: 8px;
        padding: 6px 12px;
        font-size: 14px;
        background: #fff;
        width: 75px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background: #fef5e7;
        }
      }
    }
    /* 已绑定右侧信息区域 */
    .bind-info-group {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 220px;
      .code-text {
        font-size: 16px;
        color: #666;
        line-height: 1.5;
      }
      .icon-row {
        display: flex;
        align-items: center;
        gap: 16px;
      }
    }
    .goods-no-text {
      font-size: 16px;
      color: #666;
      margin-top: 12px;
    }
    .center-arrow {
      display: flex;
      align-items: center;
      height: 70vh;
      flex-shrink: 0;
      span {
        font-size: 48px;
        font-weight: bold;
      }
    }
    .empty-tip {
      grid-column: 1 / -1;
      text-align: center;
      padding: 60px 0;
      color: #999;
    }
  }
}
@media (max-width: 768px) {
  .bind-page-layout {
    height: auto;
    overflow: auto;
    .main-content {
      padding: 0 10px;
      height: auto;
      .top-fixed-area {
        position: relative;
        left: 0;
        right: 0;
        .search-bar .el-input {
          width: 100% !important;
        }
      }
      .page-scroll-wrap {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: auto;
        overflow: visible;
      }
      .two-col-container {
        flex-direction: column;
        height: auto;
      }
      .col-left,
      .col-right {
        width: 100%;
        height: auto;
      }
      .card-scroll-box {
        height: 50vh;
      }
      .center-arrow {
        height: auto;
        transform: rotate(90deg);
        margin: 12px 0;
      }
    }
  }
}
/*弹窗样式*/
.dialog-header-row {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 20px;
  .search-input {
    flex: 1;
  }
}
.checkbox-wrap {
  max-height: 420px;
  overflow-y: auto;
}
.two-col-checkbox {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 24px;
}
.dialog-empty {
  text-align: center;
  color: #999;
  padding: 32px 0;
}
/*编辑弹窗*/
.edit-two-col {
  display: flex;
  gap: 20px;
  position: relative;
}
// 分割线
.edit-two-col::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #f0ad4e;
  transform: translateX(-50%);
}
.edit-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
}
.edit-col-header-row {
  margin-bottom: 10px;
}
.edit-col-title {
  margin: 0;
}
.edit-search-row {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
  .edit-search {
    flex: 1;
  }
}
.edit-scroll {
  max-height: 380px;
}
</style>
